/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { styled, Theme } from '@material-ui/core';

const Overflow = styled('div')<Theme, { component?: string }>({
  overflow: 'hidden',
});

export { Overflow };
